// src/utils/diccionarioImagenes.js

import gestionEstrategicaDelAprendizajeOrganizacional_full from "../assets/cursos/cursos_full/Curso1.png";
import curso1_verti from "../assets/cursos/cursos_vertical/01V.jpg";

import gestionDelCambioOrganizacional_full from "../assets/cursos/cursos_full/02H.jpg";
import curso2_verti from "../assets/cursos/cursos_vertical/02V.jpg";

import gestionDelTalentoOrganizacional_full from "../assets/cursos/cursos_full/03H.jpg";
import curso3_verti from "../assets/cursos/cursos_vertical/03V.jpg";

import gestionEstrategicaYDePersonas_full from "../assets/cursos/cursos_full/Curso4.png";
import behavioralDesign_Full from "../assets/cursos/cursos_full/Curso5.png";



import AprendizajeYDesarrollo from '../assets/services/AprendizajeYDesarrollo.png';
import CulturaYCambio from '../assets/services/CulturaYCambio.png';
import LiderazgoYTalento from '../assets/services/LiderazgoYTalento.png';


export const imagenesCursos = {
  1: { desktop: gestionEstrategicaDelAprendizajeOrganizacional_full, mobile: curso1_verti, layout: 'bottom-left' },
  2: { desktop: gestionDelCambioOrganizacional_full, mobile: curso2_verti, layout: 'bottom-left'},
  3: { desktop: gestionDelTalentoOrganizacional_full, mobile: curso3_verti , layout: 'top-right'},
  4: { desktop: gestionEstrategicaYDePersonas_full, mobile: curso3_verti, layout: 'bottom-left' },
  5: { desktop: behavioralDesign_Full, mobile: curso3_verti, layout: 'top-right'},
};

export const imagenesServicios = {
    1: AprendizajeYDesarrollo,
    2: CulturaYCambio,
    3: LiderazgoYTalento,
};